
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StrategiesIntro from "./strategies/components/StrategiesIntro";
import ComparisonTable from "./strategies/components/ComparisonTable";
import StrategiesSections from "./strategies/components/StrategiesSections";
import { useIsMobile } from "@/hooks/use-mobile";
import ChatOption from "@/components/ChatOption";

const Strategies = () => {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section - inspired by How It Works */}
      <section className="relative px-4 py-24 bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 text-white">
        <div className="absolute inset-0 bg-[url('/lovable-uploads/3b1ecf33-16ce-4883-88ce-02a3aeecb7f1.png')] bg-center bg-no-repeat opacity-10"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="flex items-center justify-center mb-4">
            <div className="h-1 w-20 bg-corporate-secondary-100 mr-4"></div>
            <span className="text-corporate-secondary-75 font-semibold">PREMIUM STRATEGIES</span>
            <div className="h-1 w-20 bg-corporate-secondary-100 ml-4"></div>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6 leading-tight">
            Our Due Diligence Process<br />for Premium Strategies
          </h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Learn how METRADE meticulously evaluates and selects only the highest-quality
            trading strategies for our premium offering.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
      </section>

      <main className="container mx-auto px-4 py-12 max-w-[1200px] -mt-10 relative z-10">
        <StrategiesIntro />
        <ComparisonTable />
        <StrategiesSections />

        {/* Only show ChatOption on desktop */}
        {!isMobile && (
          <ChatOption />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Strategies;
